import {
  BooleanField,
  CreateButton,
  Datagrid,
  FunctionField,
  List,
  NumberField,
  TextField,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { Box } from "@mui/material";

type Bank = {
  id: string;
  name: string;
  logo: string | null;
  fee_pct: number;
  comment: string | null;
  sort_order: number;
  enabled: boolean;
};

const isImage = (v: string) => /^(data:|https?:)/i.test(v);

const LogoCell = () => {
  const r = useRecordContext<Bank>();
  const v = r?.logo || "";
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: 1.5,
        display: "grid",
        placeItems: "center",
        overflow: "hidden",
        fontSize: 18,
        bgcolor: "action.hover",
      }}
    >
      {v ? (
        isImage(v) ? (
          <img src={v} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          v
        )
      ) : (
        "—"
      )}
    </Box>
  );
};

const Actions = () => (
  <TopToolbar>
    <CreateButton label="Добавить банк" />
  </TopToolbar>
);

export function PayerBankList() {
  return (
    <List actions={<Actions />} perPage={50} sort={{ field: "sort_order", order: "ASC" }} exporter={false}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <FunctionField label="Лого" render={() => <LogoCell />} />
        <TextField source="name" label="Название" />
        <FunctionField
          label="Комиссия"
          render={(r: Bank) => (Number(r.fee_pct) ? `${Number(r.fee_pct)}%` : "без комиссии")}
        />
        <FunctionField
          label="Комментарий"
          render={(r: Bank) => r.comment || "—"}
        />
        <NumberField source="sort_order" label="Порядок" />
        <BooleanField source="enabled" label="Включён" />
      </Datagrid>
    </List>
  );
}
